import { render } from "./HomeView.vue?vue&type=template&id=0cb5d50e&scoped=true"
const script = {}

import "./HomeView.vue?vue&type=style&index=0&id=0cb5d50e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cb5d50e"]])

export default __exports__